/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const noticedMuscle = useStore((state) => state.noticedMuscle);
  const setNoticedMuscle = useStore((state) => state.setNoticedMuscle);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.noticedMuscle.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={noticedMuscle}
          onChange={(value: string) => {
            setNoticedMuscle(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'noticed-muscle',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes'}>{t('onboarding.noticedMuscle.options.yes')}</Option>
          <Option value={'No'}>{t('onboarding.noticedMuscle.options.no')}</Option>
          <Option value={'Not sure'}>{t('onboarding.noticedMuscle.options.notSure')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
